"use client";

import Image from "next/image";
import useEmblaCarousel from "embla-carousel-react";
import Autoplay from "embla-carousel-autoplay";
import { useCallback } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function Services() {
    const cards = [
        { icon: "/serv1.svg", title: "Live Garba Singing", text: "Energetic and engaging Garba performances for Navratri celebrations, cultural festivals, and community events." },
        { icon: "/serv2.svg", title: "Bhajan Sandhya & Satsang Programs", text: "Soulful devotional singing and spiritual music programs designed to create a meaningful and uplifting atmosphere." },
        { icon: "/serv3.svg", title: "DJ Services for Weddings & Events", text: "Professional DJ entertainment featuring a perfect blend of Bollywood, Punjabi, Gujarati, and international music." },
        { icon: "/serv4.svg", title: "Dhol & Live Percussion Performances", text: "Dynamic live dhol and percussion performances that add excitement and energy to weddings, parties, and special occasions." },
        { icon: "/serv5.svg", title: "Corporate & Cultural Events", text: "Customized musical entertainment for corporate functions, cultural programs, festivals, and community gatherings." },
        { icon: "/serv6.svg", title: "Private Celebrations & Community Functions", text: "Music and entertainment services tailored for birthdays, anniversaries, family events, and social celebrations." },
    ];

    const [emblaRef, emblaApi] = useEmblaCarousel(
        {
            loop: true,
            align: "start",
            slidesToScroll: 1,
            breakpoints: {
                '(max-width: 1024px)': { slidesToScroll: 1 },
                '(max-width: 768px)': { slidesToScroll: 1 }
            }
        },
        [Autoplay({ delay: 3000, stopOnInteraction: false, stopOnMouseEnter: true })]
    );

    const scrollPrev = useCallback(() => {
        if (emblaApi) emblaApi.scrollPrev();
    }, [emblaApi]);

    const scrollNext = useCallback(() => {
        if (emblaApi) emblaApi.scrollNext();
    }, [emblaApi]);

    return (
        <div className="px-[5%] w-full py-16 sm:pb-[5vw] sm:py-0 flex flex-col items-center relative z-10" id="services">
            <h2 className="text-3xl md:text-[3vw] font-semibold bg-linear-to-r from-[#859AA3] to-[#006EE9] bg-clip-text text-transparent mb-8 sm:mb-[2.2vw] text-center">
                Services Offered
            </h2>

            <div className="w-full relative group">
                <button
                    onClick={scrollPrev}
                    className="absolute left-[1vw] sm:left-[-4vw] top-1/2 -translate-y-1/2 z-10 w-10 h-10 md:w-[2vw] md:h-[2vw] rounded-xl bg-white/10 hover:bg-white/20 text-white backdrop-blur-sm flex items-center justify-center transition-all"
                    aria-label="Previous slide"
                >
                    <ChevronLeft className="w-6 h-6 md:w-[1vw] md:h-[1vw]" />
                </button>

                <div className="w-full overflow-hidden" ref={emblaRef}>
                    <div className="flex -ml-4 py-5">
                        {cards.map((card, index) => (
                            <div
                                key={index}
                                className="min-w-0 shrink-0 grow-0 pl-4 w-full sm:w-1/2 md:w-1/3 lg:w-1/4"
                            >
                                <div className="h-full flex flex-col p-6 sm:p-[1.5vw] rounded-2xl border border-[#4c1e7e] bg-linear-to-br from-[#400077]/80 via-black/80 to-[#0a0410]/80 backdrop-blur-sm gap-4 transition-transform hover:scale-[1.02] duration-300 text-center items-center text-white">
                                    <div className="w-12 h-12 md:w-[3vw] md:h-[3vw]">
                                        <Image
                                            src={card.icon}
                                            alt={card.title}
                                            width={60}
                                            height={60}
                                            className="w-full h-full object-contain"
                                        />
                                    </div>
                                    <div className="flex flex-col gap-2">
                                        <h3 className="text-lg md:text-[1.2vw] leading-tight text-[#FF66D9]">
                                            {card.title}
                                        </h3>
                                        <p className="md:text-[1.1vw] leading-normal">
                                            {card.text}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <button
                    onClick={scrollNext}
                    className="absolute right-[1vw] sm:right-[-4vw] top-1/2 -translate-y-1/2 z-10 w-10 h-10 md:w-[2vw] md:h-[2vw] rounded-xl bg-white/10 hover:bg-white/20 text-white backdrop-blur-sm flex items-center justify-center transition-all"
                    aria-label="Next slide"
                >
                    <ChevronRight className="w-6 h-6 md:w-[1vw] md:h-[1vw]" />
                </button>
            </div>
        </div>
    )
}